import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
//import { useSalesStore } from '@/store/sales';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';

import Cards from '@/components/reports/cards/SubIvaTotal.vue'

//const salesStore = useSalesStore();



//const data = computed(() => salesStore.sales);


export default /*@__PURE__*/_defineComponent({
  __name: 'Container',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Cards)
  ]))
}
}

})